import * as graphic from 'echarts/lib/util/graphic';
import { Path, PathProps } from 'zrender';

export function createEl(elOption: { type: string }): Path<PathProps> {
  const graphicType = elOption.type;
  if (!graphicType) {
    return null;
  }
  if (graphicType === 'group') {
    return new graphic.Group();
  }

  let Clz = graphic.getShapeClass(graphicType);
  if (!Clz) {
    //
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    Clz = graphic[graphicType.substring(0, 1).toUpperCase() + graphicType.substring(1)];
  }
  if (!Clz) {
    throw new Error(`graphic type "${graphicType}" can not be found.`);
  }

  return new Clz();
}
